import React from "react";
import { useSelector } from "react-redux";

// Reusable Button component
const Button = ({ text, isActive, onClick }) => (
  <div
    onClick={onClick}
    className={`cursor-pointer mx-2 font-worksans font-light text-base tracking-tight text-center rounded-full shadow-md flex items-center justify-center transition-colors duration-300 ease-in-out ${
      isActive ? "bg-[#e17954] text-white" : "bg-white text-[#50869A]"
    } px-6 h-[42px]`}
  >
    {text}
  </div>
);

export const NavFrame = ({ onTabClick, hasRpmAccess, activeTab }) => {
  const homescreen = useSelector(state => state.userPrivileges.homescreen);
  // ✅ Define tabs as objects with unique IDs (no index dependency)
  const allTabs = [
 { id: 10, label: "Non - Visit Notes", requiresHomescreen: "Threads" },
    { id: 1, label: "Labs" },
    { id: 2, label: "Document" },
    { id: 3, label: "Vitals" },
    { id: 4, label: "RPM", requires: true },
    { id: 5, label: "Prior Visits" },
    // { id: 6, label: "Imaging" },
    // { id: 7, label: "Forms" },
    { id: 8, label: "CCM" },
    { id: 9, label: "Medications" },
    { id: 11, label: "CareIQ" },
  ];

  // ✅ Filter tabs based on RPM access
const tabs = allTabs.filter((tab) => {
  // RPM condition
  if (tab.requires && !hasRpmAccess) return false;

  // Homescreen privilege condition
  if (tab.requiresHomescreen && !homescreen.includes(tab.requiresHomescreen)) return false;

  return true;
});

  return (
    <div className="flex justify-start w-full pt-4">
      <div className="w-[100%] flex justify-start items-center">
        <div
          className="w-full h-[50px] bg-no-repeat bg-cover"
          style={{ backgroundImage: "url(/group-75.png)" }}
        >
          <div className="flex items-center justify-start px-1.5 ml-[30px]">
            {tabs.map((tab) => (
              <Button
                key={tab.id}
                text={tab.label}
                isActive={activeTab === tab.id}
                onClick={() => onTabClick(tab.id)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
